<div class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" style="width: 100%;">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card " style="border-color: transparent">
            <img src="{{urlBanner}}" alt="Logo-Norm35" class="centradoIMG ">
        </div>
        <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->
    <!-- CONTENT -->
    <div class="content-card" style="margin-top: 2%; margin-left: 5%; margin-right: 15%;">
        <table class="taskTables table table-striped table-bordered" style="width: 100%; margin-top: 1%;">
            <thead>
                <tr style="width: 100%;">
                    <th style="width: 70%;">{{ 'WIZARD.LISTATAREAS.LABEL01' | translate}}</th>

                    <th style="width: 10%;"></th>
                </tr>
            </thead>
            <tbody *ngFor="let tasklist of arrayTodoList; let k = index;">
                <!-- *ngFor="let tasklist of TaskListtmp" -->
                <tr style="width: 100%;" *ngFor="let taskPrimary of tasklist.tareas">
                    <td style="width:70%; text-align: justify; " *ngIf="taskPrimary.estatus == null || taskPrimary.estatus=='' || taskPrimary.estatus=='No cumple'  ">
                        {{taskPrimary.descripcion}}
                    </td>

                    <td style="width:10%; text-align: left; " *ngIf="taskPrimary.estatus == null || taskPrimary.estatus=='' || taskPrimary.estatus=='No cumple' ">
                        <button mat-icon-button aria-label=" " routerLink="{{ArrayPath[k]}}">
                            {{ 'WIZARD.LISTATAREAS.LABEL04' | translate}}
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

    </div><br><br>

</div>
<!-- / CENTER -->